import React from "react";

import { useGetFootprintingBeefPrimaryDataById, useTranslation } from "utils";

import { AlertBanner, Card, Flex, Icon, PageSpin, Tag, Typography } from "components";

type BeefGettingStartedProps = {
  primaryDataId?: string;
};

const INFO_ITEMS = [
  "beefGettingStartedForm.info.gain",
  "beefGettingStartedForm.info.breakdown",
  "beefGettingStartedForm.info.compare",
  "beefGettingStartedForm.info.discover",
  "beefGettingStartedForm.info.track",
];

const BEEF_LIST_FILES = [
  "beefSales",
  "cowCull",
  "cattleMovement",
  "concentrateFeed",
  "forage",
  "agSupport",
  "nutrientManagement",
  "electricity",
  "diesel",
  "contractor",
];

const BeefGettingStartedForm = ({ primaryDataId }: BeefGettingStartedProps) => {
  const { t } = useTranslation("footprintingBeef");
  const { isLoading } = useGetFootprintingBeefPrimaryDataById(primaryDataId ?? "");

  if (isLoading) return <PageSpin />;

  return (
    <Flex vertical gap={16}>
      <Card border className="padding-200">
        {/* TODO: Replace with non-AI image */}
        {/* <Flex gap="1rem" vertical>
          <LazyLoadImage alt={"/images/onboarding/dairy.webp"} aria-label="farm-logo-image" src={"/images/onboarding/dairy.webp"} />
        </Flex> */}
        <Flex gap={8} vertical>
          {INFO_ITEMS.map((item) => (
            <Flex key={item} align="center" gap={8}>
              <Icon size={24} iconName="tabler/circle-check" className="input-label-info-icon margin-left-0" />
              <Typography variant="paragraph-m">{t(item)}</Typography>
            </Flex>
          ))}
        </Flex>
      </Card>

      <Card border dataTestId="footprinting-beef-getting-started-form" className="padding-200">
        <Flex vertical gap={16}>
          <Flex vertical gap={4}>
            <Flex justify="space-between" align="center">
              <Typography variant="h3">{t("beefGettingStartedForm.documents")}</Typography>
              <Tag colour="blue" size="large" text={t("beefGettingStartedForm.tag")} className="center" />
            </Flex>
            <Typography variant="paragraph-m" color="grey-600" className="margin-0">
              {t("beefGettingStartedForm.documentsDescription")}
            </Typography>
          </Flex>

          <Flex vertical gap={4}>
            {BEEF_LIST_FILES.map((file) => (
              <div key={file}>
                <Typography variant="paragraph-m" className="margin-right-50">
                  •
                </Typography>
                <Typography variant="paragraph-m">{t(`beefGettingStartedForm.beefListFiles.${file}`)}</Typography>
              </div>
            ))}
          </Flex>

          <AlertBanner
            headingSize="h6"
            gap={12}
            title={t("beefGettingStartedForm.alertBanner.title")}
            description={t("beefGettingStartedForm.alertBanner.description")}
            iconName="tabler/bulb"
            iconSize={24}
            type="recommended"
            iconAlign="start"
          />
        </Flex>
      </Card>

      <AlertBanner
        headingSize="h6"
        gap={12}
        title={t("beefGettingStartedForm.infoBanner.title")}
        description={t("beefGettingStartedForm.infoBanner.description")}
        iconName="tabler/info-circle"
        iconSize={24}
        type="info"
        iconAlign="start"
      />
    </Flex>
  );
};

BeefGettingStartedForm.Key = "beef.gettingStarted";
export { BeefGettingStartedForm };
